import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RevokePointsModal from './RevokePointsModal';
import {submitRevokePointsAction, endRevokePointsAction} from '../../../actions';

const mapStateToProps = state => {
  const {revokingPoints, currentUser, currentRevocation, revokePointsSubmitted} = state.userManagement;

  return revokingPoints ? {
    modalOpen: revokingPoints,
    revoking: revokePointsSubmitted,
    email: currentUser.email,
    amount: currentRevocation.amount
  } : {};
};

const mapDispatchToProps = dispatch => bindActionCreators({
  confirm: submitRevokePointsAction,
  cancel: endRevokePointsAction
}, dispatch);

const RevokePointsModalContainer = connect(mapStateToProps, mapDispatchToProps)(RevokePointsModal);

export default RevokePointsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/RevokePointsModal/RevokePointsModalContainer.jsx